// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IntegrationEntitiesTypeahead_IntegrationEntityFragment = { __typename?: 'IntegrationEntity', id: string, integrationID: string, name: string, externalKind?: Types.IntegrationEntityExternalKind | null, value?: CurrencyUSD | null, integrationClient?: { __typename?: 'IntegrationClient', id: string, name: string } | null, entities?: Array<{ __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } }> | null };

export type GetIntegrationEntitiesQueryVariables = Types.Exact<{
  optionsLike?: Types.InputMaybe<Types.IntegrationEntityWhereInput>;
  selectedOptionsLike?: Types.InputMaybe<Types.IntegrationEntityWhereInput>;
  first: Types.Scalars['Int']['input'];
}>;


export type GetIntegrationEntitiesQuery = { __typename?: 'Query', queryData: { __typename?: 'IntegrationEntityConnection', totalCount: number, edges?: Array<{ __typename?: 'IntegrationEntityEdge', node?: (
        { __typename?: 'IntegrationEntity' }
        & IntegrationEntitiesTypeahead_IntegrationEntityFragment
      ) | null } | null> | null }, selectedData: { __typename?: 'IntegrationEntityConnection', totalCount: number, edges?: Array<{ __typename?: 'IntegrationEntityEdge', node?: (
        { __typename?: 'IntegrationEntity' }
        & IntegrationEntitiesTypeahead_IntegrationEntityFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    GetIntegrationEntities: 'GetIntegrationEntities' as const
  },
  Fragment: {
    IntegrationEntitiesTypeahead_IntegrationEntity: 'IntegrationEntitiesTypeahead_IntegrationEntity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const IntegrationEntitiesTypeahead_IntegrationEntityFragmentDoc = gql`
    fragment IntegrationEntitiesTypeahead_IntegrationEntity on IntegrationEntity {
  id
  integrationID
  name
  externalKind
  value
  integrationClient {
    id
    name
  }
  entities {
    id
    subtype {
      id
      displayName
    }
  }
}
    `;
export const GetIntegrationEntitiesDocument = gql`
    query GetIntegrationEntities($optionsLike: IntegrationEntityWhereInput, $selectedOptionsLike: IntegrationEntityWhereInput, $first: Int!) {
  queryData: integrationEntities(where: $optionsLike, first: $first) {
    totalCount
    edges {
      node {
        ...IntegrationEntitiesTypeahead_IntegrationEntity
      }
    }
  }
  selectedData: integrationEntities(where: $selectedOptionsLike, first: 500) {
    totalCount
    edges {
      node {
        ...IntegrationEntitiesTypeahead_IntegrationEntity
      }
    }
  }
}
    ${IntegrationEntitiesTypeahead_IntegrationEntityFragmentDoc}`;

/**
 * __useGetIntegrationEntitiesQuery__
 *
 * To run a query within a React component, call `useGetIntegrationEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationEntitiesQuery({
 *   variables: {
 *      optionsLike: // value for 'optionsLike'
 *      selectedOptionsLike: // value for 'selectedOptionsLike'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetIntegrationEntitiesQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationEntitiesQuery, GetIntegrationEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationEntitiesQuery, GetIntegrationEntitiesQueryVariables>(GetIntegrationEntitiesDocument, withFetchPolicyContext(options));
      }
export function useGetIntegrationEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationEntitiesQuery, GetIntegrationEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationEntitiesQuery, GetIntegrationEntitiesQueryVariables>(GetIntegrationEntitiesDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetIntegrationEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIntegrationEntitiesQuery, GetIntegrationEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntegrationEntitiesQuery, GetIntegrationEntitiesQueryVariables>(GetIntegrationEntitiesDocument, withFetchPolicyContext(options));
        }
export type GetIntegrationEntitiesQueryHookResult = ReturnType<typeof useGetIntegrationEntitiesQuery>;
export type GetIntegrationEntitiesLazyQueryHookResult = ReturnType<typeof useGetIntegrationEntitiesLazyQuery>;
export type GetIntegrationEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationEntitiesSuspenseQuery>;
export type GetIntegrationEntitiesQueryResult = Apollo.QueryResult<GetIntegrationEntitiesQuery, GetIntegrationEntitiesQueryVariables>;